import { createTemplateFactory } from "@ember/template-factory";
export default createTemplateFactory(
/*
  {{! template-lint-disable no-duplicate-id }}
<DModal
  class="create-account -large"
  {{on "keydown" this.actionOnEnter}}
  {{on "click" this.selectKitFocus}}
  @closeModal={{@closeModal}}
  @bodyClass={{this.modalBodyClasses}}
  @flash={{this.flash}}
  @flashType="error"
  aria-labelledby="create-account-title"
>
  <:body>
    <PluginOutlet
      @name="create-account-before-modal-body"
      @connectorTagName="div"
    />

    <div
      class={{concat-class
        (if this.site.desktopView "login-left-side")
        this.model.authOptions.auth_provider
      }}
    >
      <div class="login-welcome-header" id="create-account-title">
        <h1 class="login-title">{{i18n "create_account.header_title"}}</h1>
        <img src={{this.wavingHandURL}} alt="" class="waving-hand" />
        <p class="login-subheader">{{i18n "create_account.subheader_title"}}</p>
        <PluginOutlet
          @name="create-account-header-bottom"
          @outletArgs={{hash showLogin=(route-action "showLogin")}}
        />
      </div>

      {{#if this.showCreateForm}}
        <form id="login-form">
          {{#if this.associateHtml}}
            <div class="input-group create-account-associate-link">
              <span>{{html-safe this.associateHtml}}</span>
            </div>
          {{/if}}
          <div class="input-group create-account-email">
            <Input
              {{on "focusout" this.checkEmailAvailability}}
              @type="email"
              @value={{this.model.accountEmail}}
              disabled={{this.emailDisabled}}
              autofocus="autofocus"
              aria-describedby="account-email-validation account-email-validation-more-info"
              aria-invalid={{this.emailValidation.failed}}
              name="email"
              id="new-account-email"
              class={{value-entered this.model.accountEmail}}
            />
            <label class="alt-placeholder" for="new-account-email">
              {{i18n "user.email.title"}}
              {{~#if this.userFields~}}
                <span class="required">*</span>
              {{/if}}
            </label>
            <InputTip
              @validation={{this.emailValidation}}
              id="account-email-validation"
            />
            <span class="more-info" id="account-email-validation-more-info">
              {{i18n "user.email.instructions"}}
            </span>
          </div>

          <div class="input-group create-account__username">
            <Input
              @value={{this.model.accountUsername}}
              disabled={{this.usernameDisabled}}
              maxlength={{this.maxUsernameLength}}
              aria-describedby="username-validation username-validation-more-info"
              aria-invalid={{this.usernameValidation.failed}}
              autocomplete="off"
              name="username"
              id="new-account-username"
              class={{value-entered this.model.accountUsername}}
            />
            <label class="alt-placeholder" for="new-account-username">
              {{i18n "user.username.title"}}
              {{~#if this.userFields~}}
                <span class="required">*</span>
              {{/if}}
            </label>

            <InputTip
              @validation={{this.usernameValidation}}
              id="username-validation"
            />
            <span class="more-info" id="username-validation-more-info">
              {{i18n "user.username.instructions"}}
            </span>
          </div>

          <div class="input-group create-account__fullname">
            {{#if this.fullnameRequired}}
              <TextField
                @disabled={{this.nameDisabled}}
                @value={{this.model.accountName}}
                @id="new-account-name"
                aria-describedby="fullname-validation fullname-validation-more-info"
                aria-invalid={{this.nameValidation.failed}}
                class={{value-entered this.model.accountName}}
              />
              <label class="alt-placeholder" for="new-account-name">
                {{i18n "user.name.title"}}
                {{#if this.siteSettings.full_name_required}}
                  {{~#if this.userFields~}}
                    <span class="required">*</span>
                  {{/if}}
                {{/if}}
              </label>

              <InputTip
                @validation={{this.nameValidation}}
                id="fullname-validation"
              />
              <span class="more-info" id="fullname-validation-more-info">
                {{this.nameInstructions}}
              </span>
            {{/if}}
          </div>

          <PluginOutlet
            @name="create-account-before-password"
            @outletArgs={{hash
              accountName=this.model.accountName
              accountUsername=this.model.accountUsername
              accountPassword=this.accountPassword
              userFields=this.userFields
              authOptions=this.model.authOptions
            }}
          />

          <div class="input-group create-account__password">
            {{#if this.passwordRequired}}
              <PasswordField
                @value={{this.accountPassword}}
                @capsLockOn={{this.capsLockOn}}
                type={{if this.maskPassword "password" "text"}}
                autocomplete="current-password"
                aria-describedby="password-validation password-validation-more-info"
                aria-invalid={{this.passwordValidation.failed}}
                id="new-account-password"
                class={{value-entered this.accountPassword}}
              />
              <label class="alt-placeholder" for="new-account-password">
                {{i18n "user.password.title"}}
                {{~#if this.userFields~}}
                  <span class="required">*</span>
                {{/if}}
              </label>

              <div class="create-account__password-info">
                <div class="create-account__password-tip-validation">
                  <InputTip
                    @validation={{this.passwordValidation}}
                    id="password-validation"
                  />
                  <span class="more-info" id="password-validation-more-info">
                    {{this.passwordInstructions}}
                  </span>
                  <div
                    class={{concat-class
                      "caps-lock-warning"
                      (unless this.capsLockOn "hidden")
                    }}
                  >
                    {{d-icon "exclamation-triangle"}}
                    {{i18n "login.caps_lock_warning"}}
                  </div>
                </div>
                <TogglePasswordMask
                  @maskPassword={{this.maskPassword}}
                  @togglePasswordMask={{this.togglePasswordMask}}
                />
              </div>
            {{/if}}

            <div class="password-confirmation">
              <label for="new-account-password-confirmation">
                {{i18n "user.password_confirmation.title"}}
              </label>
              <HoneypotInput
                @id="new-account-confirmation"
                @autocomplete="new-password"
                @value={{this.accountHoneypot}}
              />
              <Input
                @value={{this.accountChallenge}}
                id="new-account-challenge"
              />
            </div>
          </div>

          {{#if this.requireInviteCode}}
            <div class="input-group create-account__invite-code">
              <Input
                @value={{this.inviteCode}}
                id="inviteCode"
                class={{value-entered this.inviteCode}}
              />
              <label class="alt-placeholder" for="invite-code">
                {{i18n "user.invite_code.title"}}
              </label>
              <span class="more-info">
                {{i18n "user.invite_code.instructions"}}
              </span>
            </div>
          {{/if}}

          <PluginOutlet
            @name="create-account-after-password"
            @outletArgs={{hash
              accountName=this.model.accountName
              accountUsername=this.model.accountUsername
              accountPassword=this.accountPassword
              userFields=this.userFields
            }}
          />

          {{#if this.userFields}}
            <div class="user-fields">
              {{#each this.userFields as |f|}}
                <div class="input-group">
                  <UserField
                    @field={{f.field}}
                    @value={{f.value}}
                    @validation={{f.validation}}
                    class={{value-entered f.value}}
                  />
                </div>
              {{/each}}
            </div>
          {{/if}}

          <PluginOutlet
            @name="create-account-after-user-fields"
            @outletArgs={{hash
              accountName=this.model.accountName
              accountUsername=this.model.accountUsername
              accountPassword=this.accountPassword
              userFields=this.userFields
            }}
          />
        </form>

        {{#if this.site.desktopView}}
          <div class="d-modal__footer">
            <div class="disclaimer">
              {{html-safe this.disclaimerHtml}}
            </div>
            <div class="d-modal__footer-buttons">
              <DButton
                @action={{this.createAccount}}
                @disabled={{this.submitDisabled}}
                @label="create_account.title"
                @isLoading={{this.formSubmitted}}
                class="btn-large btn-primary"
              />

              {{#unless this.hasAuthOptions}}
                <DButton
                  @action={{route-action "showLogin"}}
                  @disabled={{this.formSubmitted}}
                  @label="log_in"
                  id="login-link"
                  class="btn-large btn-flat"
                />
              {{/unless}}
            </div>
          </div>

          <PluginOutlet
            @name="create-account-after-modal-footer"
            @connectorTagName="div"
          />
        {{/if}}
      {{/if}}

      {{#if this.model.skipConfirmation}}
        {{loading-spinner size="large"}}
      {{/if}}
    </div>

    {{#if this.hasAtLeastOneLoginButton}}
      {{#if this.site.mobileView}}
        <div class="login-or-separator"><span>
            {{i18n "login.or"}}</span></div>{{/if}}
      <div class="login-right-side">
        <LoginButtons
          @externalLogin={{this.externalLogin}}
          @context="create-account"
        />
      </div>
    {{/if}}
  </:body>

  <:footer>
    {{#if (and this.showCreateForm this.site.mobileView)}}
      <div class="disclaimer">
        {{html-safe this.disclaimerHtml}}
      </div>
      <div class="d-modal__footer-buttons">
        <DButton
          @action={{this.createAccount}}
          @disabled={{this.submitDisabled}}
          @label="create_account.title"
          @isLoading={{this.formSubmitted}}
          class="btn-large btn-primary"
        />

        {{#unless this.hasAuthOptions}}
          <DButton
            @action={{route-action "showLogin"}}
            @disabled={{this.formSubmitted}}
            @label="log_in"
            id="login-link"
            class="btn-large btn-flat"
          />
        {{/unless}}
      </div>

      <PluginOutlet
        @name="create-account-after-modal-footer"
        @connectorTagName="div"
      />
    {{/if}}
  </:footer>
</DModal>
*/
{
  "id": "u1lansJO",
  "block": "[[[8,[39,0],[[24,0,\"create-account -large\"],[24,\"aria-labelledby\",\"create-account-title\"],[4,[38,1],[\"keydown\",[30,0,[\"actionOnEnter\"]]],null],[4,[38,1],[\"click\",[30,0,[\"selectKitFocus\"]]],null]],[[\"@closeModal\",\"@bodyClass\",\"@flash\",\"@flashType\"],[[30,1],[30,0,[\"modalBodyClasses\"]],[30,0,[\"flash\"]],\"error\"]],[[\"body\",\"footer\"],[[[[1,\"\\n    \"],[8,[39,2],null,[[\"@name\",\"@connectorTagName\"],[\"create-account-before-modal-body\",\"div\"]],null],[1,\"\\n\\n    \"],[10,0],[15,0,[28,[37,3],[[52,[30,0,[\"site\",\"desktopView\"]],\"login-left-side\"],[30,0,[\"model\",\"authOptions\",\"auth_provider\"]]],null]],[12],[1,\"\\n      \"],[10,0],[14,0,\"login-welcome-header\"],[14,1,\"create-account-title\"],[12],[1,\"\\n        \"],[10,\"h1\"],[14,0,\"login-title\"],[12],[1,[28,[35,5],[\"create_account.header_title\"],null]],[13],[1,\"\\n        \"],[10,\"img\"],[15,\"src\",[30,0,[\"wavingHandURL\"]]],[14,\"alt\",\"\"],[14,0,\"waving-hand\"],[12],[13],[1,\"\\n        \"],[10,2],[14,0,\"login-subheader\"],[12],[1,[28,[35,5],[\"create_account.subheader_title\"],null]],[13],[1,\"\\n        \"],[8,[39,2],null,[[\"@name\",\"@outletArgs\"],[\"create-account-header-bottom\",[28,[37,6],null,[[\"showLogin\"],[[28,[37,7],[\"showLogin\"],null]]]]]],null],[1,\"\\n      \"],[13],[1,\"\\n\\n\"],[41,[30,0,[\"showCreateForm\"]],[[[1,\"        \"],[10,\"form\"],[14,1,\"login-form\"],[12],[1,\"\\n\"],[41,[30,0,[\"associateHtml\"]],[[[1,\"            \"],[10,0],[14,0,\"input-group create-account-associate-link\"],[12],[1,\"\\n              \"],[10,1],[12],[1,[28,[35,8],[[30,0,[\"associateHtml\"]]],null]],[13],[1,\"\\n            \"],[13],[1,\"\\n\"]],[]],null],[1,\"          \"],[10,0],[14,0,\"input-group create-account-email\"],[12],[1,\"\\n            \"],[8,[39,9],[[16,\"disabled\",[30,0,[\"emailDisabled\"]]],[24,\"autofocus\",\"autofocus\"],[24,\"aria-describedby\",\"account-email-validation account-email-validation-more-info\"],[16,\"aria-invalid\",[30,0,[\"emailValidation\",\"failed\"]]],[24,3,\"email\"],[24,1,\"new-account-email\"],[16,0,[28,[37,10],[[30,0,[\"model\",\"accountEmail\"]]],null]],[4,[38,1],[\"focusout\",[30,0,[\"checkEmailAvailability\"]]],null]],[[\"@type\",\"@value\"],[\"email\",[30,0,[\"model\",\"accountEmail\"]]]],null],[1,\"\\n            \"],[10,\"label\"],[14,0,\"alt-placeholder\"],[14,\"for\",\"new-account-email\"],[12],[1,\"\\n              \"],[1,[28,[35,5],[\"user.email.title\"],null]],[41,[30,0,[\"userFields\"]],[[[10,1],[14,0,\"required\"],[12],[1,\"*\"],[13],[1,\"\\n\"]],[]],null],[1,\"            \"],[13],[1,\"\\n            \"],[8,[39,11],[[24,1,\"account-email-validation\"]],[[\"@validation\"],[[30,0,[\"emailValidation\"]]]],null],[1,\"\\n            \"],[10,1],[14,0,\"more-info\"],[14,1,\"account-email-validation-more-info\"],[12],[1,\"\\n              \"],[1,[28,[35,5],[\"user.email.instructions\"],null]],[1,\"\\n            \"],[13],[1,\"\\n          \"],[13],[1,\"\\n\\n          \"],[10,0],[14,0,\"input-group create-account__username\"],[12],[1,\"\\n            \"],[8,[39,9],[[16,\"disabled\",[30,0,[\"usernameDisabled\"]]],[16,\"maxlength\",[30,0,[\"maxUsernameLength\"]]],[24,\"aria-describedby\",\"username-validation username-validation-more-info\"],[16,\"aria-invalid\",[30,0,[\"usernameValidation\",\"failed\"]]],[24,\"autocomplete\",\"off\"],[24,3,\"username\"],[24,1,\"new-account-username\"],[16,0,[28,[37,10],[[30,0,[\"model\",\"accountUsername\"]]],null]]],[[\"@value\"],[[30,0,[\"model\",\"accountUsername\"]]]],null],[1,\"\\n            \"],[10,\"label\"],[14,0,\"alt-placeholder\"],[14,\"for\",\"new-account-username\"],[12],[1,\"\\n              \"],[1,[28,[35,5],[\"user.username.title\"],null]],[41,[30,0,[\"userFields\"]],[[[10,1],[14,0,\"required\"],[12],[1,\"*\"],[13],[1,\"\\n\"]],[]],null],[1,\"            \"],[13],[1,\"\\n\\n            \"],[8,[39,11],[[24,1,\"username-validation\"]],[[\"@validation\"],[[30,0,[\"usernameValidation\"]]]],null],[1,\"\\n            \"],[10,1],[14,0,\"more-info\"],[14,1,\"username-validation-more-info\"],[12],[1,\"\\n              \"],[1,[28,[35,5],[\"user.username.instructions\"],null]],[1,\"\\n            \"],[13],[1,\"\\n          \"],[13],[1,\"\\n\\n          \"],[10,0],[14,0,\"input-group create-account__fullname\"],[12],[1,\"\\n\"],[41,[30,0,[\"fullnameRequired\"]],[[[1,\"              \"],[8,[39,12],[[24,\"aria-describedby\",\"fullname-validation fullname-validation-more-info\"],[16,\"aria-invalid\",[30,0,[\"nameValidation\",\"failed\"]]],[16,0,[28,[37,10],[[30,0,[\"model\",\"accountName\"]]],null]]],[[\"@disabled\",\"@value\",\"@id\"],[[30,0,[\"nameDisabled\"]],[30,0,[\"model\",\"accountName\"]],\"new-account-name\"]],null],[1,\"\\n              \"],[10,\"label\"],[14,0,\"alt-placeholder\"],[14,\"for\",\"new-account-name\"],[12],[1,\"\\n                \"],[1,[28,[35,5],[\"user.name.title\"],null]],[1,\"\\n\"],[41,[30,0,[\"siteSettings\",\"full_name_required\"]],[[[41,[30,0,[\"userFields\"]],[[[10,1],[14,0,\"required\"],[12],[1,\"*\"],[13],[1,\"\\n\"]],[]],null]],[]],null],[1,\"              \"],[13],[1,\"\\n\\n              \"],[8,[39,11],[[24,1,\"fullname-validation\"]],[[\"@validation\"],[[30,0,[\"nameValidation\"]]]],null],[1,\"\\n              \"],[10,1],[14,0,\"more-info\"],[14,1,\"fullname-validation-more-info\"],[12],[1,\"\\n                \"],[1,[30,0,[\"nameInstructions\"]]],[1,\"\\n              \"],[13],[1,\"\\n\"]],[]],null],[1,\"          \"],[13],[1,\"\\n\\n          \"],[8,[39,2],null,[[\"@name\",\"@outletArgs\"],[\"create-account-before-password\",[28,[37,6],null,[[\"accountName\",\"accountUsername\",\"accountPassword\",\"userFields\",\"authOptions\"],[[30,0,[\"model\",\"accountName\"]],[30,0,[\"model\",\"accountUsername\"]],[30,0,[\"accountPassword\"]],[30,0,[\"userFields\"]],[30,0,[\"model\",\"authOptions\"]]]]]]],null],[1,\"\\n\\n          \"],[10,0],[14,0,\"input-group create-account__password\"],[12],[1,\"\\n\"],[41,[30,0,[\"passwordRequired\"]],[[[1,\"              \"],[8,[39,13],[[24,\"autocomplete\",\"current-password\"],[24,\"aria-describedby\",\"password-validation password-validation-more-info\"],[16,\"aria-invalid\",[30,0,[\"passwordValidation\",\"failed\"]]],[24,1,\"new-account-password\"],[16,0,[28,[37,10],[[30,0,[\"accountPassword\"]]],null]],[16,4,[52,[30,0,[\"maskPassword\"]],\"password\",\"text\"]]],[[\"@value\",\"@capsLockOn\"],[[30,0,[\"accountPassword\"]],[30,0,[\"capsLockOn\"]]]],null],[1,\"\\n              \"],[10,\"label\"],[14,0,\"alt-placeholder\"],[14,\"for\",\"new-account-password\"],[12],[1,\"\\n                \"],[1,[28,[35,5],[\"user.password.title\"],null]],[41,[30,0,[\"userFields\"]],[[[10,1],[14,0,\"required\"],[12],[1,\"*\"],[13],[1,\"\\n\"]],[]],null],[1,\"              \"],[13],[1,\"\\n\\n              \"],[10,0],[14,0,\"create-account__password-info\"],[12],[1,\"\\n                \"],[10,0],[14,0,\"create-account__password-tip-validation\"],[12],[1,\"\\n                  \"],[8,[39,11],[[24,1,\"password-validation\"]],[[\"@validation\"],[[30,0,[\"passwordValidation\"]]]],null],[1,\"\\n                  \"],[10,1],[14,0,\"more-info\"],[14,1,\"password-validation-more-info\"],[12],[1,\"\\n                    \"],[1,[30,0,[\"passwordInstructions\"]]],[1,\"\\n                  \"],[13],[1,\"\\n                  \"],[10,0],[15,0,[28,[37,3],[\"caps-lock-warning\",[52,[51,[30,0,[\"capsLockOn\"]]],\"hidden\"]],null]],[12],[1,\"\\n                    \"],[1,[28,[35,15],[\"exclamation-triangle\"],null]],[1,\"\\n                    \"],[1,[28,[35,5],[\"login.caps_lock_warning\"],null]],[1,\"\\n                  \"],[13],[1,\"\\n                \"],[13],[1,\"\\n                \"],[8,[39,16],null,[[\"@maskPassword\",\"@togglePasswordMask\"],[[30,0,[\"maskPassword\"]],[30,0,[\"togglePasswordMask\"]]]],null],[1,\"\\n              \"],[13],[1,\"\\n\"]],[]],null],[1,\"\\n            \"],[10,0],[14,0,\"password-confirmation\"],[12],[1,\"\\n              \"],[10,\"label\"],[14,\"for\",\"new-account-password-confirmation\"],[12],[1,\"\\n                \"],[1,[28,[35,5],[\"user.password_confirmation.title\"],null]],[1,\"\\n              \"],[13],[1,\"\\n              \"],[8,[39,17],null,[[\"@id\",\"@autocomplete\",\"@value\"],[\"new-account-confirmation\",\"new-password\",[30,0,[\"accountHoneypot\"]]]],null],[1,\"\\n              \"],[8,[39,9],[[24,1,\"new-account-challenge\"]],[[\"@value\"],[[30,0,[\"accountChallenge\"]]]],null],[1,\"\\n            \"],[13],[1,\"\\n          \"],[13],[1,\"\\n\\n\"],[41,[30,0,[\"requireInviteCode\"]],[[[1,\"            \"],[10,0],[14,0,\"input-group create-account__invite-code\"],[12],[1,\"\\n              \"],[8,[39,9],[[24,1,\"inviteCode\"],[16,0,[28,[37,10],[[30,0,[\"inviteCode\"]]],null]]],[[\"@value\"],[[30,0,[\"inviteCode\"]]]],null],[1,\"\\n              \"],[10,\"label\"],[14,0,\"alt-placeholder\"],[14,\"for\",\"invite-code\"],[12],[1,\"\\n                \"],[1,[28,[35,5],[\"user.invite_code.title\"],null]],[1,\"\\n              \"],[13],[1,\"\\n              \"],[10,1],[14,0,\"more-info\"],[12],[1,\"\\n                \"],[1,[28,[35,5],[\"user.invite_code.instructions\"],null]],[1,\"\\n              \"],[13],[1,\"\\n            \"],[13],[1,\"\\n\"]],[]],null],[1,\"\\n          \"],[8,[39,2],null,[[\"@name\",\"@outletArgs\"],[\"create-account-after-password\",[28,[37,6],null,[[\"accountName\",\"accountUsername\",\"accountPassword\",\"userFields\"],[[30,0,[\"model\",\"accountName\"]],[30,0,[\"model\",\"accountUsername\"]],[30,0,[\"accountPassword\"]],[30,0,[\"userFields\"]]]]]]],null],[1,\"\\n\\n\"],[41,[30,0,[\"userFields\"]],[[[1,\"            \"],[10,0],[14,0,\"user-fields\"],[12],[1,\"\\n\"],[42,[28,[37,19],[[28,[37,19],[[30,0,[\"userFields\"]]],null]],null],null,[[[1,\"                \"],[10,0],[14,0,\"input-group\"],[12],[1,\"\\n                  \"],[8,[39,20],[[16,0,[28,[37,10],[[30,2,[\"value\"]]],null]]],[[\"@field\",\"@value\",\"@validation\"],[[30,2,[\"field\"]],[30,2,[\"value\"]],[30,2,[\"validation\"]]]],null],[1,\"\\n                \"],[13],[1,\"\\n\"]],[2]],null],[1,\"            \"],[13],[1,\"\\n\"]],[]],null],[1,\"\\n          \"],[8,[39,2],null,[[\"@name\",\"@outletArgs\"],[\"create-account-after-user-fields\",[28,[37,6],null,[[\"accountName\",\"accountUsername\",\"accountPassword\",\"userFields\"],[[30,0,[\"model\",\"accountName\"]],[30,0,[\"model\",\"accountUsername\"]],[30,0,[\"accountPassword\"]],[30,0,[\"userFields\"]]]]]]],null],[1,\"\\n        \"],[13],[1,\"\\n\\n\"],[41,[30,0,[\"site\",\"desktopView\"]],[[[1,\"          \"],[10,0],[14,0,\"d-modal__footer\"],[12],[1,\"\\n            \"],[10,0],[14,0,\"disclaimer\"],[12],[1,\"\\n              \"],[1,[28,[35,8],[[30,0,[\"disclaimerHtml\"]]],null]],[1,\"\\n            \"],[13],[1,\"\\n            \"],[10,0],[14,0,\"d-modal__footer-buttons\"],[12],[1,\"\\n              \"],[8,[39,21],[[24,0,\"btn-large btn-primary\"]],[[\"@action\",\"@disabled\",\"@label\",\"@isLoading\"],[[30,0,[\"createAccount\"]],[30,0,[\"submitDisabled\"]],\"create_account.title\",[30,0,[\"formSubmitted\"]]]],null],[1,\"\\n\\n\"],[41,[51,[30,0,[\"hasAuthOptions\"]]],[[[1,\"                \"],[8,[39,21],[[24,1,\"login-link\"],[24,0,\"btn-large btn-flat\"]],[[\"@action\",\"@disabled\",\"@label\"],[[28,[37,7],[\"showLogin\"],null],[30,0,[\"formSubmitted\"]],\"log_in\"]],null],[1,\"\\n\"]],[]],null],[1,\"            \"],[13],[1,\"\\n          \"],[13],[1,\"\\n\\n          \"],[8,[39,2],null,[[\"@name\",\"@connectorTagName\"],[\"create-account-after-modal-footer\",\"div\"]],null],[1,\"\\n\"]],[]],null]],[]],null],[1,\"\\n\"],[41,[30,0,[\"model\",\"skipConfirmation\"]],[[[1,\"        \"],[1,[28,[35,22],null,[[\"size\"],[\"large\"]]]],[1,\"\\n\"]],[]],null],[1,\"    \"],[13],[1,\"\\n\\n\"],[41,[30,0,[\"hasAtLeastOneLoginButton\"]],[[[41,[30,0,[\"site\",\"mobileView\"]],[[[1,\"        \"],[10,0],[14,0,\"login-or-separator\"],[12],[10,1],[12],[1,\"\\n            \"],[1,[28,[35,5],[\"login.or\"],null]],[13],[13]],[]],null],[1,\"\\n      \"],[10,0],[14,0,\"login-right-side\"],[12],[1,\"\\n        \"],[8,[39,23],null,[[\"@externalLogin\",\"@context\"],[[30,0,[\"externalLogin\"]],\"create-account\"]],null],[1,\"\\n      \"],[13],[1,\"\\n\"]],[]],null],[1,\"  \"]],[]],[[[1,\"\\n\"],[41,[28,[37,24],[[30,0,[\"showCreateForm\"]],[30,0,[\"site\",\"mobileView\"]]],null],[[[1,\"      \"],[10,0],[14,0,\"disclaimer\"],[12],[1,\"\\n        \"],[1,[28,[35,8],[[30,0,[\"disclaimerHtml\"]]],null]],[1,\"\\n      \"],[13],[1,\"\\n      \"],[10,0],[14,0,\"d-modal__footer-buttons\"],[12],[1,\"\\n        \"],[8,[39,21],[[24,0,\"btn-large btn-primary\"]],[[\"@action\",\"@disabled\",\"@label\",\"@isLoading\"],[[30,0,[\"createAccount\"]],[30,0,[\"submitDisabled\"]],\"create_account.title\",[30,0,[\"formSubmitted\"]]]],null],[1,\"\\n\\n\"],[41,[51,[30,0,[\"hasAuthOptions\"]]],[[[1,\"          \"],[8,[39,21],[[24,1,\"login-link\"],[24,0,\"btn-large btn-flat\"]],[[\"@action\",\"@disabled\",\"@label\"],[[28,[37,7],[\"showLogin\"],null],[30,0,[\"formSubmitted\"]],\"log_in\"]],null],[1,\"\\n\"]],[]],null],[1,\"      \"],[13],[1,\"\\n\\n      \"],[8,[39,2],null,[[\"@name\",\"@connectorTagName\"],[\"create-account-after-modal-footer\",\"div\"]],null],[1,\"\\n\"]],[]],null],[1,\"  \"]],[]]]]]],[\"@closeModal\",\"f\"],false,[\"d-modal\",\"on\",\"plugin-outlet\",\"concat-class\",\"if\",\"i18n\",\"hash\",\"route-action\",\"html-safe\",\"input\",\"value-entered\",\"input-tip\",\"text-field\",\"password-field\",\"unless\",\"d-icon\",\"toggle-password-mask\",\"honeypot-input\",\"each\",\"-track-array\",\"user-field\",\"d-button\",\"loading-spinner\",\"login-buttons\",\"and\"]]",
  "moduleName": "discourse/components/modal/create-account.hbs",
  "isStrictMode": false
});